import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from '../inc/header';
import Footer from '../inc/footer';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

function Index() {
    return (
        <>
            <style type="text/css">
                {` 
            .right-columns p {
                color: #e5d8d8;
                line-height: 49px;
                border-bottom: 1px solid white;
                margin: 0 0 20px;
            }
            #content_section p,ul,h1{
                text-align: justify !important;
            }
                 .job-post p{
            color: white !important;
        }
        .border-color-light, .border-light {
            border-color: #272761 !important;
        }
        .text-pink{
            color: #E6178B !important;
        }

        .text-blue{
            color: #272761 !important;
        }
             .services-sticky-container {
                position: sticky;
                top: 100px; 
                display: flex;
                flex-direction: column;
                align-items: center;
                z-index: 10;
            }

            .vertical-line-black {
                width: 2px;
                height: 150px;
                background-color: black;
                margin: 10px 0;
            }

            @media (max-width: 767px) {
                .services-sticky-container {
                    display: none; 
                }
            }
            `}
            </style>
            <div>
                <Helmet>
                    <title>GSPWLL - Downloads</title>
                    <meta name="description" content="Contact TourX Pro for your travel needs." />
                    <meta property="og:title" content="TourX Pro - Contact" />
                    <meta property="og:description" content="Contact TourX Pro for your travel needs." />
                </Helmet>

                <div className="body">

                    <Header />
                    <main role="main" class="main" style={{ background: '#212529', position: 'relative' }}>
                        <section
                            className="page-header page-header-modern page-header-background overlay overlay-color-dark overlay-show overlay-op-7"
                            style={{
                                backgroundImage: "url('/assets/img/slides/page-header-services.jpg')",
                            }}
                        >
                            <div className="container">
                                <div className="row mt-5">
                                    <div className="col-md-12 align-self-center text-center">
                                        <h1 className="text-10">
                                            <strong>Downloads</strong>
                                        </h1>
                                    </div>
                                </div>
                            </div>
                        </section>



                        <section
                            className="section section-parallax bg-color-grey border-0 m-0 mt-0 p-0 "
                            style={{
                                borderBottomRightRadius: '0px',
                                background: 'white',
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                overflow: 'hidden',
                            }} >
                            <div className="container-fluid h-100 p-0 mt-5  " style={{ width: '70%' }}>
                                {/* Sticky Sidebar */}
                                <div className="row h-100 m-0">
                                    {/* Left Column - Google Map */}
                                    <div className="col-lg-12 p-0">
                                        <h1 class="custom-heading">Downloads</h1>
                                        <ul className="list-unstyled">
                                            {[1, 2, 3, 4].map((item, idx) => (
                                                <li
                                                    key={idx}
                                                    className="mb-3 border-bottom pb-2"
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <span className="text-dark flex-grow-1">Integrated LNG Services</span>
                                                        <span className="text-muted large me-5">3.56MB</span>
                                                        <span className="text-muted large me-5"> PDF</span>
                                                        <i className="fas fa-angle-right text-secondary"></i>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                        <h1 class="custom-heading mb-3">Inspection UT</h1>
                                        <ul className="list-unstyled">
                                            {[1, 2, 3, 4].map((item, idx) => (
                                                <li
                                                    key={idx}
                                                    className="mb-3 border-bottom pb-2"
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <span className="text-dark flex-grow-1">Integrated LNG Services</span>
                                                        <span className="text-muted large me-5">3.56MB</span>
                                                        <span className="text-muted large me-5"> PDF</span>
                                                        <i className="fas fa-angle-right text-secondary"></i>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </section>

                    </main>

                </div>
            </div>
            <Footer />
        </>
    );
}

export default Index;
